var indentStyle = {"indentZero":"G40DA","indentOne":"XFyJr","indentTwo":"_8MxA7","indentThree":"_3T7K7","indentFour":"zrUgG","indentFive":"_8tdtX","indentSix":"_6eft2"};

export { indentStyle as i };
//# sourceMappingURL=indentation-ecafa52f.js.map
